<div class="aft-layout">
  <div class="aft-layout--navbar">
    <fk-navbar
      version="v2.0"
      appName="Antifraud Tools Frogo"
      [profile]="userName$ | async"
      [menuItems]="menuItems$ | async"
      [secondaryMenuItems]="secondaryMenuItems$ | async"
      [selectOptions]="sharedOrganizations$ | async"
      [selectedOption]="selectedOrganization$ | async"
      [invates]="invites$ | async"
      [canAcceptInvites]="canAcceptInvites$ | async"
      [profileInfo]="userName$ | async"
      [i18n]="i18nNavMenu"
      (optionSelected)="switchOrganization($event)"
      (acceptInvite)="acceptInvite($event)"
      (rejectInvite)="rejectInvite($event)"
      (openProfile)="openProfile()"
      >
      <ng-template #logoImg>
        <img src="../../../assets/img/frogo-logo.svg"/>
      </ng-template>
      <div
        fkNavbarLang
        class="aft-navbar-lang-select fk-ph3">
        @for (option of langOptions; track option.lang) {
          <button
            *ngIf="selectedLang$ | async as selectedLang"
            class="aft-navbar-lang-select-btn fk-mr3"
            [class.aft-navbar-lang-select-btn__active]="option.lang === selectedLang"
            (click)="switchLanguage(option.lang, selectedLang)"
            type="button">
            <img [src]="option.icon"/>
          </button>
        }
      </div>
      <ng-container fkNavbarActions>
        <button
          class="frogo-navbar--profile-panel-btn fk-mt4"
          (click)="changePassword()"
        >
          <fk-icon name="lock" class="fk-mr3"></fk-icon>
          {{ 'layoutNavigation.changePassword' | translate }}
        </button>
        <button
          *ngIf="(requiredUser2FAInit$ | async) && (canReadOtp$ | async)"
          class="frogo-navbar--profile-panel-btn fk-mt4"
          (click)="openSetup2FAModal()"
        >
          <fk-icon name="key" class="fk-mr3"></fk-icon>
          {{ 'layoutNavigation.2FA' | translate }}
        </button>
        <button
          class="frogo-navbar--profile-panel-btn fk-mt4"
          (click)="logout()">
          <fk-icon name="logout" class="fk-mr3"></fk-icon>
          {{ 'layoutNavigation.logOut' | translate }}
        </button>
      </ng-container>
    </fk-navbar>
  </div>
  <div class="aft-layout--content fk-default">
    <router-outlet></router-outlet>
  </div>
</div>
